module.exports = {"percentiles":"百分位數","byteincomingpercentilesnum":"th 百分位數（傳入用量）","traffic":"用量","maximum":"最大值","minimum":"最小值","byteoutgoingpercentilesnum":"th 百分位數（傳出用量）","byteincominglinechart":"傳入用量趨勢","byteoutgoinglinechart":"傳出用量趨勢","search":"搜尋","exportPdf":"匯出 PDF","moreInfo":"更多資訊","ipRange":"IP 地址範圍","timeRange":"時間範圍"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/netflowAnalyze.json
// module id = tKYw
// module chunks = 3